export default [pitchCardController]

const pitchStatusMap = {
  pitched: {
    display: 'Pitched',
    iconClass: { 'fa-flag': true },
  },
  'not watching': {
    display: 'Not Watching',
    iconClass: { 'fa-eye-slash': true },
  },
  watching: {
    display: 'Watching',
    iconClass: { 'fa-eye': true },
  },
  saving: {
    display: 'Saving',
    iconClass: { 'fa-thumb-tack': true },
  },
  used: {
    display: 'Used',
    iconClass: { 'fa-check-circle': true },
  },
  withdrawn: {
    display: 'Withdrawn',
    iconClass: { 'fa-flag-o': true },
  },
}

function pitchCardController() {
  this.$onInit = () => {
    let st = pitchStatusMap[this.pitch.currentStatus]
    this.pitchType = this.pitch.hasOwnProperty('platformName')
      ? 'platform'
      : 'publication'
    this.pitchLabel =
      this.pitch.platformName || this.pitch.publicationName || 'Untitled'
    this.statusText = st ? st.display : this.pitch.currentStatus || 'Unknown'
    this.statusIconClass = st ? st.iconClass : {}
  }
}
